import React, {useContext} from 'react';
import { IMenuItem } from "../../core/interfaces/IMenuItem";
import {formatToRandWithDecimalsString} from "../../core/helpers/textFormatting";
import {findUnavailableRequiredOptionSet} from "../../core/helpers/optionSetSelection";
import {GreenBoxNumber} from "../views/GreenBoxNumber";
import {HalfwayContext} from "../../context/HalfwayContext";
import {HalfwayContextType} from "../../types/HalfwayContextType";

export interface IMenuItemProps {
    menuItem: IMenuItem,
}

export const MenuItem = (props: IMenuItemProps) => {

    const {
        toggleProductDrawer
    } = useContext(HalfwayContext) as HalfwayContextType;

    return(
        <div    className='mx-4 my-2 bg-white rounded-2xl border border-slate-100 shadow-card overflow-hidden
                           transition-all duration-200 ease-out cursor-pointer
                           hover:shadow-card-hover active:scale-[0.98]'
                key={props.menuItem.id}
                onClick={() => toggleProductDrawer(props.menuItem)}>
            <div className='flex items-start p-4 gap-3'>

                {/* Text content */}
                <div className='flex flex-col flex-1 min-w-0'>
                    <span className='font-semibold text-slate-900 text-sm leading-snug'>
                        {props.menuItem.name}
                    </span>
                    {findUnavailableRequiredOptionSet(props.menuItem.optionSets ?? []) && (
                        <span className='text-xs font-semibold text-red-700 mt-1'>Unavailable — required options are unavailable</span>
                    )}
                    {props.menuItem.description && (
                        <span className='text-xs text-slate-400 mt-1 line-clamp-2 leading-relaxed'>
                            {props.menuItem.description}
                        </span>
                    )}
                    <span className='text-sm font-semibold text-accent-green mt-2'>
                        {formatToRandWithDecimalsString(props.menuItem.basePrice ?? props.menuItem.price ?? 0)}
                    </span>
                </div>

                {/* Badge */}
                {props.menuItem.totalInBasket !== 0 && (
                    <div className='flex-shrink-0 mt-0.5'>
                        <GreenBoxNumber value={props.menuItem.totalInBasket}/>
                    </div>
                )}

            </div>
        </div>
    )
    
}
